import type { PersonalKeycard } from 'cleverev-types'
import { api } from './api'


class PersonalKeycardAPI {

  public async listpersonalKeycards(organizationId: string) {
    const result = await api.get<{ personalKeycards: PersonalKeycard[]; totalCount: number }>(`/organizations/${organizationId}/personal-keycards?take=9999`) // TODO: implement pagination

    return result.data
  }

  public async get(personalKeycardId: string) {
    const result = await api.get<{ personalKeycard: PersonalKeycard }>(`/personal-keycards/${personalKeycardId}`)
    // const userEmail = await api.get(`/users/${result.data.personalKeycard.userId}`)

    return { personalKeycard: result.data.personalKeycard, userEmail: null } // userEmail.data.email
  }

  public async create(newPersonalKeycard: Partial<PersonalKeycard>) {
    const result = await api.post<{ personalKeycard: PersonalKeycard }>(
      '/personal-keycards/assign',
      newPersonalKeycard
    )

    return result.data.personalKeycard
  }

  public async delete(id: string) {
    await api.delete(`/personal-keycard/${id}/unassign`)

    return null
  }

}

export const personalKeycardAPI = new PersonalKeycardAPI()
